import React, { useEffect, useState } from "react";
import { apiJson } from "../../auth/authClient";

const API = "/api/udrzba";

export default function UdrzbaCenik() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    apiJson(`${API}/cenik`, { method: "GET" })
      .then((d) => setItems(Array.isArray(d?.items) ? d.items : []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Ceník</h2>
      <div style={{ display: "grid", gap: 10 }}>
        {items.map((it) => (
          <div key={it.id} style={{ border: "1px solid #e5e7eb", borderRadius: 14, padding: 14 }}>
            <div style={{ fontWeight: 700 }}>{it.nazev}</div>
            <div style={{ color: "#6b7280", marginTop: 4 }}>{it.skupina}</div>
            <div style={{ marginTop: 6 }}>
              {Number(it.cenaBezDph || 0).toLocaleString("cs-CZ")} Kč bez DPH • DPH {it.dph} %
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
